<script>
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';
import Form from '../form';

export default {
  extends: TablePage,
  name: 'level_adjustment_management',
  components: {
    Modal,
    Form,
  },
  data() {
    return {
      requestUrl: '/cps/fxh/terminalAdjustController/findByConditions',
      requestType: 'GET',
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('level_adjustment_management');
  },
  methods: {
    // 按钮点击事件
    modalClick({ val, row }) {
      console.log({ val, row });
      console.log('this.formConfig', this.formConfig);

      if (['add', 'view'].includes(val.code)) {
        this.formConfig = {};
        this.formName = 'Form';
        if (val.code === 'view') {
          this.modalConfig.title = '查看';
        } else {
          this.modalConfig.title = '新增';
        }
        this.modalConfig.width = '70%';
        this.modalConfig.height = '600px';
        this.formConfig = {
          type: val.code,
          id: row.id || '',
          code: val.code || '',
        };
        this.openFull();
      }
    },
  },
};
</script>
